import { z } from 'zod';

export enum SensorType {
  HOME = 'HOME',
  TOUCH = 'TOUCH',
  TH_TRIFORCE_BUTTON = 'TH TRIFORCE_BUTTON',
  TH_TRIFORCE_WEIGHT = 'TH TRIFORCE_WEIGHT',
  TH_PUSH = 'TH_PUSH',
  GENERIC = 'GENERIC',
  UHF_NEO_DESKTOP = 'UHF_NEO_DESKTOP',
  NEXMO_PRESENCE_XY240 = 'NEXMO_PRESENCE_XY240',
  NEXMO_PICKUP = 'NEXMO_PICKUP',
  NEXMO_NFC = 'NEXMO_NFC',
  SPLITSCREEN = 'SPLITSCREEN',
  NEXMO_BUTTON = 'NEXMO_BUTTON',
  TH_LINK = 'TH_LINK',
  TH_NFC = 'TH_NFC',
  EMPTY = '',
}

export const SensorTypeSchema = z.nativeEnum(SensorType);
